!function (n) {
  let e = n.document,
    t = e.documentElement,
    i = 1334,
    d = i / 100,
    o = "orientationchange" in n ? "orientationchange" : "resize",
    a = function () {
      let n = t.clientWidth || 750; n > 1334 && (n = 1334);
      var u = navigator.userAgent;
      // window.alert(screen.width+'=='+screen.height)
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (!isIOS && screen.height >= 360 && screen.width >= 760) {
        t.style.fontSize = "47px";
      } else if (!isIOS && screen.height == 694 && screen.width == 320) {
        
        t.style.fontSize = "18.5px";
      } else if (!isIOS && screen.height == 320  && screen.width == 694) {
        t.style.fontSize = "32px";
      } else {
        t.style.fontSize = n / d + "px";
      }
    };
  e.addEventListener && (n.addEventListener(o, a, !1), e.addEventListener("DOMContentLoaded", a, !1))
}(window);


// WEBPACK FOOTER //
// ./src/common/js/rem.js